// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"461":"1db0ed36","851":"54b6d387"}[chunkId] + ".css";
};